<template>
  <div class="v3-widget v3-panel" v-testid="testid">
    <div class="v3-panel-head">
      <h3 v-testid="testid + '-title'">{{ title }}</h3>
      <span v-if="subtitle" class="sub">{{ subtitle }}</span>
    </div>
    <V3Skeleton v-if="fb.isLoading.value && !fb.count.value" shape="list" :heading="false" />
    <div v-else class="v3-out-list">
      <div v-for="(it, i) in fb.items.value" :key="i" class="v3-out-row">
        <span class="v3-out-ic" :class="`v3-out-ic--${st(it).tone}`"><span class="ms">{{ st(it).icon }}</span></span>
        <div class="v3-out-main">
          <div class="v3-out-title">{{ it.title }}</div>
          <div v-if="sub(it)" class="v3-out-sub">{{ sub(it) }}</div>
        </div>
        <span class="v3-pill" :class="`v3-pill--${st(it).tone}`">{{ st(it).label }}</span>
      </div>
      <div v-if="!fb.count.value" class="v3-out-empty" v-testid="testid + '-empty'">Submitted work and its outcome will appear here.</div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { outcomes } from "@rm-ui/homepage/outcomes";
import V3Skeleton from "./cLandingV3Skeleton";

// New-portal (v3) FeedbackStrip — the design's "After you submit" outcome list,
// over the shared `outcomes` composable (@rm-ui/homepage/outcomes, POST
// Report/outcomes). Authored static `items` override the live feed. Sibling:
// rm-portal-beta FeedbackStripWidget.vue.
const STATUS = {
  approved: { label: "Approved", tone: "green", icon: "check_circle" },
  submitted: { label: "Submitted", tone: "accent", icon: "hourglass_top" },
  "in-progress": { label: "In progress", tone: "accent", icon: "hourglass_top" },
  returned: { label: "Sent back", tone: "amber", icon: "undo" },
  ready: { label: "Ready", tone: "neutral", icon: "schedule" },
};

export default {
  name: "cLandingV3FeedbackStrip",
  components: { V3Skeleton },
  props: {
    definition: { type: Object, default: () => ({}) },
    editMode: { type: Boolean, default: false },
    qaActions: { type: Array, default: () => [] },
  },
  setup(props) {
    const fb = outcomes({
      http: axios,
      getLimit: () => 6,
      getStaticItems: () => props.definition.items || [],
    });
    return { fb };
  },
  computed: {
    testid() {
      return this.definition.controlType || "v3FeedbackStrip";
    },
    title() {
      return this.definition.title || "After you submit";
    },
    subtitle() {
      return this.definition.subtitle || "Outcomes land here";
    },
  },
  methods: {
    st(it) {
      return (
        STATUS[(it && it.status) || ""] || {
          label: (it && it.status) || "",
          tone: "neutral",
          icon: "fiber_manual_record",
        }
      );
    },
    sub(it) {
      return [it.detail, it.when].filter(Boolean).join(" · ");
    },
  },
};
</script>

<style lang="scss" src="./v3Widgets.scss"></style>
